import Daily from "./daily/daily";

export default {
  modules: { Daily },
};
